<template>
  <div :class="$style.wrap">
    <a v-for="(item, key) in list" :key="key" :href="item.link" target="_blank">
      <div :class="$style.cell">
        <img :src="item.icon" :class="$style.icon" />
        <div :class="$style.title">
          <van-tag
            v-if="item.tag"
            :color="tags[item.tag].color"
            :class="$style.tag"
            >{{ tags[item.tag].text }}</van-tag
          >
          <p>
            <strong>《{{ item.name }}》</strong>
          </p>
          <p>{{ item.desc }}</p>
        </div>
        <van-icon name="arrow" :class="$style.arrow" />
      </div>
    </a>
  </div>
</template>

<script>
import { Tag } from "vant";

export default {
  name: "BaseGameList",
  components: { [Tag.name]: Tag },
  props: ["list"],
  data() {
    return {
      tags: {
        1: {
          text: "新游",
          color: "#ff781e"
        },
        2: {
          text: "火爆",
          color: "#ff2626"
        },
        3: {
          text: "测试",
          color: "#00dfc8"
        },
        4: {
          text: "经典",
          color: "#d9b85e"
        }
      }
    };
  }
};
</script>

<style module lang="less">
.wrap {
  margin: 0 @padding-md;
}

.cell {
  .flex-align-center;
  margin-top: @padding-lg;
  padding: @padding-md @padding-lg;
  background-color: #f5f5f5;
  color: #9d9d9d;
}

.icon {
  .size(1.47rem);
  margin-right: @padding-lg;
}

.title {
  flex: 1;

  p:not(:first-child) {
    margin-top: 0.5em;
  }

  strong {
    position: relative;
    left: -0.4em;
    font-size: 0.28rem;
    color: @text-color;
  }
}

.tag {
  justify-content: center;
  width: 0.98rem;
  padding: 0;
  border-radius: 0;
  font-size: @font-size-sm;
  line-height: 0.34rem;
}

.arrow {
  font-size: @font-size-lg;
}
</style>
